import React from "react";

import { Input } from "~/ui/legacyFellowIndex";

import styles from "./RecentChats.module.css";

export function AskFellowConversationSearchBar({
	value,
	onValueChange,
}: {
	value: string;
	onValueChange: (newValue: string) => void;
}) {
	const onChange = React.useCallback(
		(e: React.FormEvent<HTMLInputElement>) => {
			onValueChange(e.currentTarget.value);
		},
		[onValueChange],
	);

	return (
		<Input
			className={styles.searchBar}
			type="text"
			placeholder="Search chats"
			value={value}
			onChange={onChange}
			name="ask_fellow_chat_search"
		/>
	);
}
